var moduleMap = {
	"./Utils": () => {
		return Promise.all([__webpack_require__.e(700), __webpack_require__.e(107), __webpack_require__.e(614), __webpack_require__.e(261)]).then(() => (() => ((__webpack_require__(96261)))));
	},
	"./Components": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(700), __webpack_require__.e(745), __webpack_require__.e(737), __webpack_require__.e(894)]).then(() => (() => ((__webpack_require__(73737)))));
	},
	"./Stylus": () => {
		return Promise.all([__webpack_require__.e(745), __webpack_require__.e(943)]).then(() => (() => ((__webpack_require__(16943)))));
	},
	"./Services": () => {
		return Promise.all([__webpack_require__.e(700), __webpack_require__.e(107), __webpack_require__.e(614), __webpack_require__.e(536)]).then(() => (() => ((__webpack_require__(99536)))));
	},
	"./Modules": () => {
		return Promise.all([__webpack_require__.e(124), __webpack_require__.e(700), __webpack_require__.e(745), __webpack_require__.e(107), __webpack_require__.e(737), __webpack_require__.e(78)]).then(() => (() => ((__webpack_require__(58769)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});